<script>
    import foreignGeos from "../stores/foreignGeos";
    import localGeos from "../stores/localGeos";
    import {foreignGeosLoad, geosMatch} from "../lib/requests";
    import {
        scrollToElement,
        findUnmatched,
        expandParents,
        getParentNodes,
        collapseAll,
        searchNodes,
        findNode,
        backPath,
        findNodeParentOfLevel,
        upCaseStr
    } from "../lib/lib";
    import ForeignItem from "./ForeignItem.svelte";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import error from '../stores/error';

    export let source = null;

    let pageTitle = 'Geos';
    let searchTerm
    let oldSearchTerm = '';
    let searchResults = [];
    let searchIndex = null;
    let unmatchedResults = [];
    let unmatchedIndex = null;
    let onRegionSearch = false;
    let oldSelectedId = 0;
    let selectedGeoParentPath = "";
    let loading = false;

    $localGeos.match_source = source;

    const onSearch = (event) => {
        if (event.key === 'Enter') {
            if (oldSearchTerm !== searchTerm) {
                resetSearch();
                if (searchTerm.length > 0) {

                    if (!isNaN(searchTerm)) {
                        // if search term is a location id
                        searchResults = [];
                        let node = findNode(searchTerm, $foreignGeos.tree);
                        if (node) {
                            searchResults.push(node.id);
                        }
                    } else {
                        // if search term is a string
                        let tree = $foreignGeos.tree;
                        if (onRegionSearch && $foreignGeos.selected_id > 0) {
                            // get node parent region
                            let region = findNodeParentOfLevel($foreignGeos.selected_id, 1, tree);
                            if (region) {
                                tree = region.children;
                            }
                        }

                        searchResults = searchNodes(upCaseStr(searchTerm), tree);
                    }

                    oldSearchTerm = searchTerm;
                }
                if (searchResults.length === 0) {
                    error.show("Δεν βρέθηκαν αποτελέσματα");
                } else {
                    $foreignGeos.last_selected_id = $foreignGeos.selected_id;
                }
            }
            showNextSearchResult();
        } else if (event.key === 'Escape') {
            searchTerm = '';
            resetSearch();
        }
    }

    const showNextSearchResult = () => {
        if (searchResults.length > 0) {
            if (searchIndex === null) {
                searchIndex = 0;
            } else {
                searchIndex++;
                if (searchIndex > searchResults.length - 1) {
                    searchIndex = 0;
                }
            }

            $foreignGeos.marked_id = searchResults[searchIndex];
            gotoLocation(searchResults[searchIndex]);
        }
    }

    const resetSearch = () => {
        oldSearchTerm = '';
        searchResults = [];
        searchIndex = null;
        $foreignGeos.marked_id = 0;
    }

    const onFindUnmatched = () => {
        unmatchedResults = findUnmatched($foreignGeos.matches, $foreignGeos.tree);
        unmatchedIndex = null;
    }

    const onShowNextUnmatched = () => {
        if (unmatchedIndex === null) {
            unmatchedIndex = 0;
        } else {
            unmatchedIndex++;
            if (unmatchedIndex > unmatchedResults.length - 1) {
                unmatchedIndex = 0;
            }
        }
        gotoLocation(unmatchedResults[unmatchedIndex]);
    }

    const onShowPreviusUnmatched = () => {
        if (unmatchedIndex === null) {
            unmatchedIndex = unmatchedResults.length - 1;
        } else {
            unmatchedIndex--;
            if (unmatchedIndex < 0) {
                unmatchedIndex = unmatchedResults.length - 1;
            }
        }
        gotoLocation(unmatchedResults[unmatchedIndex]);
    }

    const gotoLocation = (id, collapse_expanded = true) => {
        let node = findNode(id, $foreignGeos.tree);
        let parents = getParentNodes(node, $foreignGeos.tree);
        parents.map(item => {
            item.expanded = true;
        });
        $foreignGeos.selected_id = id;
        if (collapse_expanded) {
            onCollapseAll();
        }
        $foreignGeos.tree = $foreignGeos.tree;
        scrollToElement('kritikes-item-' + id);
    }

    const onCollapseAll = () => {
        collapseAll($foreignGeos.tree, $foreignGeos.selected_id);
        $foreignGeos.tree = $foreignGeos.tree;
        scrollToElement('kritikes-item-' + $foreignGeos.selected_id);
    }

    const onRefresh = () => {
        if ($foreignGeos.modified) {
            app_alert.show('confirm', "Να ανανεωθεί η λίστα των περιοχών;\nΟι αλλαγές που έκανες θα χαθούν!", Load);
            return;
        }
        Load();
    }

    const onMatchSelected = () => {
        if ($localGeos.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή από αριστερά!");
            return;
        }

        if ($foreignGeos.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή από δεξιά!");
            return;
        }

        // check if location has been all ready matched with an other geo
        let match = $foreignGeos.matches.find(x => x.match_id === $foreignGeos.selected_id);

        if (match && match.geo_id !== $localGeos.selected_id) {
            let geoPath = backPath($localGeos.selected_id, $localGeos.tree);
            let locationPath = backPath(match.match_id, $foreignGeos.tree);
            app_alert.show(
                'confirm',
                `Η περιοχή<br><strong>${locationPath}</strong><br>έχει ήδη συσχετιστεί με το geo <br><strong>${geoPath}</strong><br>Θέλετε να αντικαταστήσετε αυτή την συσχέτιση;`,
                () => {
                    // remove old match
                    $foreignGeos.matches = $foreignGeos.matches.filter(x => x !== match);
                    let location = findNode(match.match_id, $foreignGeos.tree);
                    location.geo_matches = null; // set to null to refresh location matches

                    matchSelected();
                }
            );
            return;
        }

        matchSelected();
    }

    const matchSelected = () => {
        let foreignNode = findNode($foreignGeos.selected_id, $foreignGeos.tree);
        if (foreignNode.match_not_allowed == 1) {
            error.show(`Δεν επιτρέπεται η αντιστοίχιση της περιοχής "${foreignNode.name}"`);
            return;
        }

        $foreignGeos.matches = [...$foreignGeos.matches, {
            geo_id: $localGeos.selected_id,
            match_id: $foreignGeos.selected_id
        }];

        // set node geo_id to null to refresh matched path
        foreignNode.geo_matches = null;

        let localNode = findNode($localGeos.selected_id, $localGeos.tree);
        localNode.geo_matches = null;
        $localGeos.tree = $localGeos.tree;

        $foreignGeos.modified = true;
        success.show("Έγινε αντιστοίχιση");
    }

    const onMatchAllNodes = () => {
        if ($localGeos.selected_id === 0 || $foreignGeos.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή και στις δυο πλευρές!");
            return;
        }

        let location = findNode($foreignGeos.selected_id, $foreignGeos.tree);
        let geo = findNode($localGeos.selected_id, $localGeos.tree);
        let geoPath = backPath($localGeos.selected_id, $localGeos.tree);
        let locationPath = backPath($foreignGeos.selected_id, $foreignGeos.tree);
        app_alert.show(
            'confirm',
            `Να αντιστοιχιθεί τη περιοχή<br><strong>${locationPath}</strong><br>και όλες οι υποπεριοχές της με την<br><strong>${geoPath}</strong><br> από το Geos;`,
            () => matchAllNodes(geo, location)
        );
    }

    const matchAllNodes = (geo, location) => {
        let match = $foreignGeos.matches.find(x => x.geo_id === geo.id && x.match_id === location.id);
        if (!match) {
            $foreignGeos.matches = [...$foreignGeos.matches, {geo_id: geo.id, match_id: location.id}];
            geo.geo_matches = null;
            location.geo_matches = null;
        }
        geo.children.map(node => {
            matchAllNodes(node, location);
        });
    }

    const onUnMatchAllNodes = () => {
        if ($localGeos.selected_id === 0 || $foreignGeos.selected_id === 0) {
            app_alert.show('error', "Δεν έχετε επιλέξει περιοχή και στις δυο πλευρές!");
            return;
        }

        let location = findNode($foreignGeos.selected_id, $foreignGeos.tree);
        let geo = findNode($localGeos.selected_id, $localGeos.tree);
        let geoPath = backPath($localGeos.selected_id, $localGeos.tree);
        let locationPath = backPath($foreignGeos.selected_id, $foreignGeos.tree);
        app_alert.show(
            'confirm',
            `Να καταργηθεί αντιστοίχιση της περιοχής<br><strong>${locationPath}</strong><br>με όλες οι υποπεριοχές της με την<br><strong>${geoPath}</strong><br> από το Geos;`,
            () => unMatchAllNodes(geo, location)
        );
    }

    const unMatchAllNodes = (geo, location) => {
        let match = $foreignGeos.matches.find(x => x.geo_id === geo.id && x.match_id === location.id);
        if (match) {
            $foreignGeos.matches = $foreignGeos.matches.filter(x => x !== match);
            geo.geo_matches = null;
            location.geo_matches = null;
        }
        geo.children.map(node => {
            unMatchAllNodes(node, location);
        });
    }

    const onGotoLastSelected = () => {
        $foreignGeos.selected_id = $foreignGeos.last_selected_id;
        scrollToElement('kritikes-item-' + $foreignGeos.selected_id);
    }

    const toggleSearchScope = () => {
        onRegionSearch = !onRegionSearch;
        resetSearch();
    }

    const setLoadedData = (data) => {
        pageTitle = data.title;

        $foreignGeos.tree = data.tree;
        $foreignGeos.matches = data.matches || [];
        $foreignGeos.modified = false;

        if ($foreignGeos.selected_id == 0 && ~~data.last_selected_id > 0) {
            $foreignGeos.selected_id = data.last_selected_id;
        }

        if ($foreignGeos.selected_id > 0) {
            expandParents($foreignGeos.selected_id, $foreignGeos.tree);
        }
    }


    const Load = async () => {
        loading = true;
        const [err, res] = await foreignGeosLoad(source);

        if (err) {
            alert('error ' + err)
            return;
        }

        setLoadedData(res);
        loading = false;
    }

    const Save = async () => {

        const [err, res] = await geosMatch(source, $foreignGeos.matches, $foreignGeos.selected_id, $localGeos.selected_id);
        if (err) {
            alert('error ' + err)
            return;
        }

        $foreignGeos.modified = false;
        success.show("Οι περιοχές ενημερώθηκαν.");
    }


    $:{
        if (!loading) {
            if (oldSelectedId !== $foreignGeos.selected_id) {
                oldSelectedId = $foreignGeos.selected_id;
                selectedGeoParentPath = backPath($foreignGeos.selected_id, $foreignGeos.tree);
            }
            if (!$foreignGeos.tree || $foreignGeos.tree.length === 0) {
                Load();
            }
            if ($foreignGeos.search_term) {
                searchTerm = $foreignGeos.search_term;
                $foreignGeos.search_term = '';
                onSearch({key: 'Enter'});
            }
            if (!searchTerm && oldSearchTerm) {
                resetSearch();
            }
        }
    }
</script>

<div class="section-header">
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" on:click="{ onCollapseAll }" title="Κατάρρευση όλων"><i
                    class="fa fa-toggle-up"></i></button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onMatchSelected }" title="Αντιστοίχιση με νέες περιοχές">
                <i class="fa fa-arrow-left"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-arrow-right"></i>
            </button>
            <button class="btn btn-primary" on:click="{ onMatchAllNodes }"
                    title="Αντιστοίχιση με όλες τις υπό περιοχές των Geos">
                <i class="fa fa-sitemap"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-arrow-right"></i>
            </button>
            <button class="btn btn-danger" on:click="{ onUnMatchAllNodes }"
                    title="Κατάργηση αντιστοίχισης με τις υπό περιοχές των Geos">
                <i class="fa fa-sitemap"></i>
                <i class="fa fa-check"></i>
                <i class="fa fa-remove"></i>
            </button>
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onFindUnmatched }" title="Εύρεση μη αντιστοιχισμένων">
                <i class="fa fa-chain-broken"></i>
                {#if unmatchedResults.length}
                    { unmatchedResults.length }
                {/if}
            </button>
            {#if unmatchedResults.length}
                <button class="btn btn-primary" on:click="{ onShowPreviusUnmatched }" title="Προηγούμενη περιοχή"><i
                        class="fa fa-arrow-left"></i></button>
                <button class="btn btn-primary" on:click="{ onShowNextUnmatched }" title="Επόμενη περιοχή"><i
                        class="fa fa-arrow-right"></i></button>
            {/if}
            <span class="separator"></span>
            <button class="btn btn-primary" on:click="{ onRefresh }" title="Ανανέωση περιοχών"><i
                    class="fa fa-refresh"></i></button>
            <button class="btn btn-primary" class:btn-primary={ !$foreignGeos.modified }
                    class:btn-danger={ $foreignGeos.modified } title="Αποθήκευση αλλαγών"
                    on:click="{ Save }"><i class="fa fa-save"></i></button>
            <span class="separator"></span>
        </div>
        <div class="col-md-4">
            <div class="form-inline text-right">
                <button class="btn btn-primary" title="αναζήτηση στον νομό" on:click="{ toggleSearchScope }">
                    {#if onRegionSearch}
                        <i class="fa fa-map"></i>
                    {:else}
                        <i class="fa fa-map-o"></i>
                    {/if}
                </button>
                <input type="text" class="form-control" bind:value="{ searchTerm }" on:keyup="{ onSearch }"
                       placeholder="αναζήτηση">
                <button class="btn btn-primary" title="επιστροφή στην αρχική επιλογή" on:click="{ onGotoLastSelected }">
                    <i class="fa fa-arrow-left"></i></button>
            </div>
        </div>
    </div>
</div>

<div class="panel">
    <div class="panel-heading foreign-heading">
        <div>
            <h2>{pageTitle}</h2>
            <h6>{ selectedGeoParentPath }</h6>
        </div>
        <div>
            Alt + Click σε περιοχή για αναζήτηση στα δεξιά
        </div>
    </div>
    <div class="panel-body fixed-height">
        <div class="panel-body-inner">
            {#if $foreignGeos.tree && $foreignGeos.tree.length > 0}
                {#each $foreignGeos.tree as location}
                    <ForeignItem location="{ location }"/>
                {/each}
            {/if}
        </div>
    </div>
</div>

<style>
    .foreign-heading {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
    }
</style>